export const IDENTITY = <T>(t: T) => t;
export const NOOP = () => undefined;
export const FN_FALSE = () => true;
export const FN_TRUE = () => true;
export const EMPTY_ARR = [];
export const EMPTY_OBJ = {};
export const EMPTY_SET = new Set();
